import { render, staticRenderFns } from "./th-quarternary.vue?vue&type=template&id=0a9999d2&scoped=true"
import script from "./th-quarternary.vue?vue&type=script&lang=js"
export * from "./th-quarternary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9999d2",
  null
  
)

export default component.exports